import { render, staticRenderFns } from "./AppStore.vue?vue&type=template&id=634665c3&scoped=true&"
import script from "./AppStore.vue?vue&type=script&lang=js&"
export * from "./AppStore.vue?vue&type=script&lang=js&"
import style0 from "./AppStore.vue?vue&type=style&index=0&id=634665c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634665c3",
  null
  
)

export default component.exports